import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 187.5 187.5"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "currentColor" }, [
      _createElementVNode("path", { d: "M121.26 111.158c-.88-11.266 36.334-10.973 36.334-10.973s-28.891-6.443-42.437 5.037c-17.143 14.526 8.725 23.742 14.54 29.657 5.817 5.936 6.391 16.323-19.19 16.908s-43.604-1.19-43.604-1.19-5.07 21.573-9.585 32.936c0 0 49.133 1.484 68.898-3.26 19.745-4.745 40.676-20.754 31.665-39.146s-35.76-18.684-36.62-29.97M49.167 27.205C22.19 27.205.321 49.52.321 77.049s38.954 49.24 48.846 104.141c13.948-54.003 48.847-76.612 48.847-104.14S76.126 27.204 49.167 27.204m0 76.24c-14.292 0-25.868-11.811-25.868-26.396s11.576-26.396 25.868-26.396 25.868 11.812 25.868 26.396-11.595 26.397-25.868 26.397M187.824 33.589c0-16.303-12.953-29.52-28.93-29.52s-28.928 13.217-28.928 29.52 23.074 29.169 28.929 61.676c8.265-31.98 28.929-45.374 28.929-61.676m-44.255 0c0-8.63 6.87-15.639 15.326-15.639s15.325 7.01 15.325 15.639-6.868 15.639-15.325 15.639-15.326-7.01-15.326-15.64" })
    ], -1)
  ])))
}
export default { render: render }